import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import * as userService from '../../services/userService';
import { User } from '../../types/user';

// استيراد مكونات مشتركة قمنا بإنشائها سابقاً
import LoadingSpinner from '../../components/common/LoadingSpinner';
import ErrorAlert from '../../components/common/ErrorAlert';
import styles from '../Page.module.css'; // ملف التنسيق العام للصفحات

const UserApprovals: React.FC = () => {
  const queryClient = useQueryClient();

  // 1. استخدام useQuery لجلب قائمة المستخدمين المعلقين
  const { data: pendingUsers, isLoading, isError, error } = useQuery<User[], Error>({
    queryKey: ['pendingUsers'], // مفتاح فريد لهذا الاستعلام
    queryFn: userService.getPendingUsers, // الدالة التي ستقوم بالجلب
  });

  // 2. استخدام useMutation لتنفيذ عملية الموافقة
  const approveMutation = useMutation({
    mutationFn: userService.approveUser, // الدالة التي ستقوم بالتغيير
    onSuccess: (approvedUser) => {
      toast.success(`تمت الموافقة على ${approvedUser.email} بنجاح!`);
      // تحديث بيانات 'pendingUsers' في الـ cache لإزالة المستخدم الموافق عليه
      queryClient.invalidateQueries({ queryKey: ['pendingUsers'] });
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'فشلت عملية الموافقة.');
    },
  });

  // دالة يتم استدعاؤها عند الضغط على زر الموافقة
  const handleApprove = (userId: number) => {
    approveMutation.mutate(userId);
  };

  // 3. عرض حالات التحميل والخطأ
  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <ErrorAlert message={error.message} />;
  }

  return (
    <div className={styles.pageContainer}>
      <h1 className={styles.pageTitle}>طلبات الموافقة على المستخدمين</h1>

      {pendingUsers && pendingUsers.length > 0 ? (
        <div className={styles.tableContainer}>
          <table>
            <thead>
              <tr>
                <th>الاسم (إن وجد)</th>
                <th>البريد الإلكتروني</th>
                <th>نوع التسجيل</th>
                <th>رقم القيد (إن وجد)</th>
                <th>إجراء</th>
              </tr>
            </thead>
            <tbody>
              {pendingUsers.map((user) => (
                <tr key={user.id}>
                  <td>{user.registration_payload?.name || 'غير متوفر'}</td>
                  <td>{user.email}</td>
                  <td>{user.registration_payload?.registrationType}</td>
                  <td>{user.registration_payload?.registrationId || 'لا يوجد'}</td>
                  <td>
                    <button
                      onClick={() => handleApprove(user.id)}
                      disabled={approveMutation.isPending}
                      className="button primary" // افترض وجود كلاس عام للأزرار
                    >
                      {approveMutation.isPending ? 'جاري...' : 'موافقة'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>لا توجد طلبات موافقة جديدة في الوقت الحالي.</p>
      )}
    </div>
  );
};

export default UserApprovals;
